import * as React from "react";

const ArrowRight = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    viewBox="0 0 16 16"
    className={className}
  >
    <path
      fill="currentColor"
      d="m13.854 8.354-4.5 4.5a.5.5 0 0 1-.708-.708L12.293 8.5H2.5a.5.5 0 1 1 0-1h9.793L8.646 3.854a.5.5 0 1 1 .708-.708l4.5 4.5a.5.5 0 0 1 0 .708"
    ></path>
  </svg>
);

export default ArrowRight;
